'use strict';

var _ = require('lodash');

/**
 * Flight Analysis - Click on Profile chart - Class Mix Chart
 */
var FlightClassMixGraphTransformerFactory = function FlightClassMixGraphTransformerFactory($filter, DataTransformer) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var MAX_DTD = 332;
  function FlightClassMixGraphTransformer() {
    DataTransformer.call(this);
    this.sourceType = ['flight-class-profile-mode', 'class', 'class-post-departure'];
    this.targetType = 'flight-class-mix-graph';
    this.priority = 0;
  }
  FlightClassMixGraphTransformer.prototype = Object.create(DataTransformer.prototype);
  FlightClassMixGraphTransformer.constructor = FlightClassMixGraphTransformer;
  FlightClassMixGraphTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType === targetType;
  };
  FlightClassMixGraphTransformer.prototype.isCacheable = function () {
    return true;
  };
  FlightClassMixGraphTransformer.prototype.getCacheKey = function (metrics) {
    return this.sourceType.join('-') + '-' + this.targetType + '-' + metrics.join('-');
  };
  FlightClassMixGraphTransformer.prototype.transform = function (data, metrics, metricDescriptor) {
    var legCabin = metricDescriptor.params.legCabin;
    var memoizedYearMonthDayOfMoment = _.memoize(getYearMonthDayOfMoment, function (moment) {
      return moment.valueOf();
    });
    metrics = metrics || [];
    var legClasses = _.filter(data.domain.flattenedDomainCurves || data.domain.results, function (curveData) {
      return _.keys(curveData).length > 2;
    });
    var metricsKeys = [];
    var mlength = metrics.length;
    for (var m = 0; m < mlength; m++) {
      metricsKeys[m] = 'm' + (m + 1) + 'curve';
    }
    var result = [];
    for (var i = 0, length = legClasses.length; i < length; i++) {
      var entry = legClasses[i];
      var flightDepartureDateMoment = legCabin.flightDepartureDateMoment;
      var legDepartureDateMoment = legCabin.legDepartureDateMoment;
      var curYMD = memoizedYearMonthDayOfMoment(flightDepartureDateMoment);
      var className = _.chain(entry.curveId).split('_').last().value();
      var newEntry = {
        leg: legCabin.leg,
        className: className,
        flightNumber: legCabin.flightNumber,
        cabinCode: legCabin.cabinCode,
        opsSuffix: legCabin.opsSuffix,
        label: className,
        flightDepartureDateMoment: flightDepartureDateMoment,
        legDepartureDateMoment: legDepartureDateMoment,
        flightDepartureDate: curYMD,
        legDepartureDate: legDepartureDateMoment.valueOf()
      };
      for (m = 0; m < mlength; m++) {
        var curMetricName = metrics[m];
        var curve = entry[curMetricName];
        var metricKey = metricsKeys[m];
        if (curve && curve.length > 0) {
          var dataKey = getDataKey(curve);
          newEntry[metricKey] = expandCurve(curve, dataKey);
        } else {
          newEntry[metricKey] = 0;
        }
      }
      result.push(newEntry);
    }
    return result;
  };
  function getDataKey(curve) {
    return _.chain(curve).first().keys().without('daysToDeparture').first().value();
  }
  function expandCurve(curve, dataKey) {
    var mappedCurve = _.reduce(curve, function (result, value) {
      result[value.daysToDeparture] = value;
      return result;
    }, {});
    var dtdRange = _.rangeRight(0, MAX_DTD);
    return _.transform(dtdRange, function (result, dtd) {
      var mapped = mappedCurve[dtd] || _.last(result);
      var value = mapped && mapped[dataKey] || 0;
      var obj = {};
      obj.daysToDeparture = dtd;
      obj[dataKey] = value;
      result.push(obj);
    }, []);
  }
  function getYearMonthDayOfMoment(moment) {
    return rmMomentFormat(moment, 'DATE_ISO');
  }
  return FlightClassMixGraphTransformer;
};
FlightClassMixGraphTransformerFactory.$inject = ['$filter', 'DataTransformerFactory'];
module.exports = FlightClassMixGraphTransformerFactory;